(function($) {

	'use strict';

	var init = function() {
        resizeVideo();
    };
    
    var resizeVideo = function(){

		// $(window).resize(function() {
        //     var videoWidth = $('.video-container iframe').outerWidth();
        //     $('.video-container iframe').height((videoWidth /16) * 9);
		// }).resize();
		
		$(window).resize(function() {
            $('iframe[src*="youtube"]').each(function() {
				$(this).height(($(this).outerWidth() / 16) * 9);
			});
		}).resize();
	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
